import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { useCallback, useEffect, useState } from "react";
import { _serverUrl2 } from "../../../config";
import { loading, removeLoading } from "../../../Utils/Alerts2";
import { BarChart } from "../../../Utils/BarChart";
import { numberConvert } from "../../../Utils/MainUtils";
import { PieChart } from "../../../Utils/PieCharts";
import ProjectSideBar from "./ProjectSideBar";

export default function Istatislik() {
  const [values, setValues] = useState([]);
  const [calismaBinaTipi, setCalismaBinaTipi] = useState([]);
  const [depremRisk, setDepremRisk] = useState([]);
  const [valuesv2, setValuesv2] = useState([]);
  const [calismaBinaTipiv2, setCalismaBinaTipiv2] = useState([]);
  const [depremRiskv2, setDepremRiskv2] = useState([]);
  const [calismaRaporu, setCalismaRaporu] = useState([]);
  const [calismaRaporuEkip, setCalismaRaporuEkip] = useState([]);
  const [calismaRaporuEkipToplam, setCalismaRaporuEkipToplam] = useState([]);
  const [calismaIlcelereGoreToplam, setCalismaIlcelereGoreToplam] = useState([]);

  const [binaStok, setBinaStok] = useState([]);
  const [binaNufus, setBinaNufus] = useState([]);
  const [, setBinaStokImarTipi] = useState([]);

  const [projects, setProjects] = useState([]);

  const [visible, setVisible] = useState(false);

  const getInfosFromNode = useCallback(async () => {
    // loading()

    await axios.get(_serverUrl2 + "/projects/depremRiskBolgesineGore").then((res) => {
      setDepremRisk(res.data.rows);
    });

    await axios.get(_serverUrl2 + "/projects/gorevStats").then((res) => {
      setValues(res.data.rows);
    });

    await axios.get(_serverUrl2 + "/projects/gorevBinaTipineGore").then((res) => {
      setCalismaBinaTipi(res.data.rows);
    });

    await axios.get(_serverUrl2 + "/projects/depremRiskBolgesineGore_versiyon2").then((res) => {
      setDepremRiskv2(res.data.rows);
    });

    await axios.get(_serverUrl2 + "/projects/gorevStats_versiyon2").then((res) => {
      setValuesv2(res.data.rows);
    });

    await axios.get(_serverUrl2 + "/projects/gorevBinaTipineGore_versiyon2").then((res) => {
      setCalismaBinaTipiv2(res.data.rows);
    });

    await axios.get(_serverUrl2 + "/projects/getAll").then((res) => {
      setProjects(res.data.rows);
    });

    let trh = formatDateToYYYYMMDD(new Date());
    console.log(trh);
    await axios.post(_serverUrl2 + "/projects/gorevCalismaRaporu", { bastrh: trh, bittrh: trh }).then((res) => {
      setCalismaRaporu(res.data.rows);
    });

    await axios.post(_serverUrl2 + "/projects/gorevCalismaRaporuEkip", { bastrh: trh, bittrh: trh }).then((res) => {
      setCalismaRaporuEkip(res.data.rows);
    });

    await axios.get(_serverUrl2 + "/projects/gorevCalismaRaporuEkipToplam").then((res) => {
      setCalismaRaporuEkipToplam(res.data.rows);
    });

    await axios.get(_serverUrl2 + "/projects/binaStokDurumu").then((res) => {
      setBinaStok(res.data.rows);
    });

    await axios.get(_serverUrl2 + "/projects/binaStokDurumu_imar_tipi").then((res) => {
      setBinaStokImarTipi(res.data.rows);
    });

    await axios.get(_serverUrl2 + "/projects/binaNufusDurumu").then((res) => {
      setBinaNufus(res.data.rows);
    });

    await axios.get(_serverUrl2 + "/projects/gorevIlcelereGoreOrtalama").then((res) => {
      setCalismaIlcelereGoreToplam(res.data.rows);
    });

    // removeLoading()
  }, []);

  const onClickCalismaRaporu = async () => {
    let bastrh = document.getElementById("bastar").value;
    let bittrh = document.getElementById("bittar").value;

    await axios.post(_serverUrl2 + "/projects/gorevCalismaRaporu", { bastrh, bittrh }).then((res) => {
      setCalismaRaporu(res.data.rows);
    });

    await axios.post(_serverUrl2 + "/projects/gorevCalismaRaporuEkip", { bastrh, bittrh }).then((res) => {
      setCalismaRaporuEkip(res.data.rows);
    });
  };

  function formatDateToYYYYMMDD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const today = new Date().toISOString().substring(0, 10);

  let onClickPrint = () => {
    loading();
    const print1 = document.getElementById("pdf1");
    const print2 = document.getElementById("pdf2");
    const print3 = document.getElementById("pdf3");
    const print4 = document.getElementById("pdf4");

    html2canvas(print1, { allowTaint: true, useCORS: true, logging: true }).then((canvas1) => {
      html2canvas(print2, { allowTaint: true, useCORS: true, logging: true }).then((canvas2) => {
        html2canvas(print3, { allowTaint: true, useCORS: true, logging: true }).then((canvas3) => {
          html2canvas(print4, { allowTaint: true, useCORS: true, logging: true }).then((canvas4) => {
            const imgData = canvas1.toDataURL("image/png");
            var imgWidth = 210;
            var pageHeight = 295;
            var imgHeight = (canvas1.height * imgWidth) / canvas1.width;
            var heightLeft = imgHeight;
            var doc = new jsPDF("p", "mm", "a4");
            var position = 0;

            doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft >= 0) {
              position = heightLeft - imgHeight;
              doc.addPage();
              doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
              heightLeft -= pageHeight;
            }
            doc.addPage();

            const imgData2 = canvas2.toDataURL("image/png");
            var imgWidth2 = 210;
            pageHeight = 295;
            imgHeight = (canvas2.height * imgWidth2) / canvas2.width;
            heightLeft = imgHeight;
            //var doc = new jsPDF('p','mm','a4');
            position = 0;

            doc.addImage(imgData2, "PNG", 0, position, imgWidth2, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft >= 0) {
              position = heightLeft - imgHeight;
              doc.addPage();
              doc.addImage(imgData2, "PNG", 0, position, imgWidth2, imgHeight);
              heightLeft -= pageHeight;
            }
            doc.addPage();

            const imgData3 = canvas3.toDataURL("image/png");
            var imgWidth3 = 210;
            pageHeight = 295;
            imgHeight = (canvas3.height * imgWidth3) / canvas3.width;
            heightLeft = imgHeight;
            //var doc = new jsPDF('p','mm','a4');
            position = 0;

            doc.addImage(imgData3, "PNG", 0, position, imgWidth3, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft >= 0) {
              position = heightLeft - imgHeight;
              doc.addPage();
              doc.addImage(imgData3, "PNG", 0, position, imgWidth3, imgHeight);
              heightLeft -= pageHeight;
            }
            doc.addPage();

            const imgData4 = canvas4.toDataURL("image/png");
            var imgWidth4 = 210;
            pageHeight = 295;
            imgHeight = (canvas4.height * imgWidth4) / canvas4.width;
            heightLeft = imgHeight;
            //var doc = new jsPDF('p','mm','a4');
            position = 0;

            doc.addImage(imgData4, "PNG", 0, position, imgWidth4, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft >= 0) {
              position = heightLeft - imgHeight;
              doc.addPage();
              doc.addImage(imgData4, "PNG", 0, position, imgWidth4, imgHeight);
              heightLeft -= pageHeight;
            }
            doc.save("Istatistikler.pdf");

            removeLoading();
          });
        });
      });
    });
  };

  const handleTabClick = (value) => {
    setVisible(value);
  };

  useEffect(() => {
    getInfosFromNode();

    return () => {};
  }, [getInfosFromNode]);

  return (
    <div className="row" style={{ fontSize: "12px" }}>
      <div className="col-12">
        <ProjectSideBar page={"1"} />
      </div>
      <div className="col-3">
        <select id="proje" style={{ height: "40px", backgroundColor: "gray", color: "white" }} className="form-select form-select-sm">
          {projects.map((d) => {
            return <option value={d.id}>{d.proje_adi}</option>;
          })}
        </select>
      </div>
      <div className="col-sm-8">
        <div className="textBox">
          <div className="content d-flex justify-content-between" style={{ backgroundColor: "gray", color: "white" }}>
            <b>&nbsp;</b>
            <b>İstatistik </b>
            <b>&nbsp;</b>
          </div>
        </div>
      </div>
      <div className="col-sm-1">
        <button className="redBtn" style={{ height: "40px" }} onClick={() => onClickPrint()}>
          PDF
        </button>
      </div>
      <div className="row" id="pdf1">
        <div className="col-sm-12" style={{ flexDirection: "columnReverse", minWidth: "300px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
          <div className="textBox" style={{ width: "100%" }}>
            <div className="header">
              <center>
                <h4>
                  <b>Kocaeli'nin Bina Stoğu</b>
                </h4>
              </center>
            </div>
            <PieChart
              data={binaStok.map((d) => {
                return parseInt(d.sayi);
              })}
              label={binaStok.map((d) => {
                return d.ad;
              })}
              toplam={binaStok.reduce((total, d) => total + parseInt(d.sayi), 0)}
            />
            <hr style={{ border: "1px solid black" }}></hr>
            {binaNufus.map((d) => {
              return (
                <div className="col-6" style={{ fontSize: "12pt", float: "left", marginTop: "5px" }}>
                  <b>{d.ad + ": " + numberConvert(d.nufus_sayisi)}</b>
                </div>
              );
            })}
          </div>
        </div>

        <div className="col-12">
          <table className="table table-bordered shadow-sm">
            <tr>
              <td style={!visible ? styles.selectedTr : styles.defaultTr} onClick={() => handleTabClick(false)}>
                1999 Öncesi
              </td>
              <td style={visible ? styles.selectedTr : styles.defaultTr} onClick={() => handleTabClick(true)}>
                2000-2007 Arası
              </td>
            </tr>
          </table>
        </div>
        {!visible ? (
          <>
            <div className="col-sm-6" style={{ flexDirection: "columnReverse", minWidth: "300px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
              <div className="textBox" style={{ width: "100%" }}>
                <div className="header">
                  <center>
                    <h4>
                      <b>Deprem Risk Bölgelerine Göre 1999 Öncesi Bina Stoğu Dağılımı</b>
                    </h4>
                  </center>
                </div>
                <PieChart
                  data={depremRisk.map((d) => {
                    return parseInt(d.sayi);
                  })}
                  label={depremRisk.map((d) => {
                    return d.deprem_zemini;
                  })}
                />
              </div>
            </div>

            <div className="col-sm-6" style={{ flexDirection: "columnReverse", minWidth: "300px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
              <div className="textBox" style={{ width: "100%" }}>
                <div className="header">
                  {/* <center><h4><b>{projects.find(e => e.id == document.getElementById('proje').value)?.proje_adi}</b></h4></center></div> */}
                  <center>
                    <h4>
                      <b> Deprem Risk Bölgelerinde Bulunan 1999 Öncesi Binaların Tespiti</b>
                    </h4>
                  </center>
                </div>
                <PieChart
                  data={values.map((d) => {
                    return parseInt(d.count);
                  })}
                  label={values.map((d) => {
                    return d.gorev_durum == "ISLEMDE" ? "İŞLEMDE" : d.gorev_durum == "SARTLI" ? "ŞARTLI" : d.gorev_durum;
                  })}
                />
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="col-sm-6" style={{ flexDirection: "columnReverse", minWidth: "300px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
              <div className="textBox" style={{ width: "100%" }}>
                <div className="header">
                  <center>
                    <h4>
                      <b>Deprem Risk Bölgelerine Göre 2000-2007 Arası Bina Stoğu Dağılımı</b>
                    </h4>
                  </center>
                </div>
                <PieChart
                  data={depremRiskv2.map((d) => {
                    return parseInt(d.sayi);
                  })}
                  label={depremRiskv2.map((d) => {
                    return d.deprem_zemini;
                  })}
                />
              </div>
            </div>

            <div className="col-sm-6" style={{ flexDirection: "columnReverse", minWidth: "300px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
              <div className="textBox" style={{ width: "100%" }}>
                <div className="header">
                  {/* <center><h4><b>{projects.find(e => e.id == document.getElementById('proje').value)?.proje_adi}</b></h4></center></div> */}
                  <center>
                    <h4>
                      <b> Deprem Risk Bölgelerinde Bulunan 2000-2007 Arası Binaların Tespiti</b>
                    </h4>
                  </center>
                </div>
                <PieChart
                  data={valuesv2.map((d) => {
                    return parseInt(d.count);
                  })}
                  label={valuesv2.map((d) => {
                    return d.gorev_durum == "ISLEMDE" ? "İŞLEMDE" : d.gorev_durum == "SARTLI" ? "ŞARTLI" : d.gorev_durum;
                  })}
                />
              </div>
            </div>
          </>
        )}
      </div>
      <div className="row" id="pdf2">
        {!visible ? (
          <>
            <div className="col-sm-12" style={{ flexDirection: "columnReverse", minWidth: "300px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
              <div className="textBox" style={{ width: "100%" }}>
                <div className="header">
                  <center>
                    <h4>
                      <b>1999 Öncesi Bina Tiplerine Göre</b>
                    </h4>
                  </center>
                </div>
                <PieChart
                  data={calismaBinaTipi.map((d) => {
                    return parseInt(d.count);
                  })}
                  label={calismaBinaTipi.map((d) => {
                    return d.sablon_adi;
                  })}
                />
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="col-sm-12" style={{ flexDirection: "columnReverse", minWidth: "300px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
              <div className="textBox" style={{ width: "100%" }}>
                <div className="header">
                  <center>
                    <h4>
                      <b> 2000-2007 Arası Bina Tiplerine Göre</b>
                    </h4>
                  </center>
                </div>
                <PieChart
                  data={calismaBinaTipiv2.map((d) => {
                    return parseInt(d.count);
                  })}
                  label={calismaBinaTipiv2.map((d) => {
                    return d.sablon_adi;
                  })}
                />
              </div>
            </div>
          </>
        )}

        <div className="col-sm-12" style={{ flexDirection: "columnReverse", minWidth: "300px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
          <div className="textBox" style={{ width: "100%" }}>
            <div className="header">
              <h4>
                <b>İlçelere Göre Ortalama Puan</b>
              </h4>
            </div>
            <div className="content">
              <BarChart
                ad={"İlçelere Göre Ortalama Puan"}
                noFixed={true}
                oran={true}
                label={calismaIlcelereGoreToplam.map((d) => {
                  return d.label;
                })}
                data={calismaIlcelereGoreToplam.map((d) => {
                  return d.val;
                })}
                count={calismaIlcelereGoreToplam.map((d) => {
                  return d.count;
                })}
                toplambina={calismaIlcelereGoreToplam.map((d) => {
                  return d.toplam_bina;
                })}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row" id="pdf3">
        <div className="col-sm-12" style={{ flexDirection: "columnReverse", minWidth: "300px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
          <div className="textBox" style={{ width: "100%" }}>
            <div className="header">
              <h4>
                <b>Ekip Toplam Çalışma Raporu</b>
              </h4>
            </div>
            <div className="content">
              <BarChart
                ad={"Ekip Toplam Çalışma Raporu"}
                noFixed={true}
                label={calismaRaporuEkipToplam.map((d) => {
                  return d.label;
                })}
                data={calismaRaporuEkipToplam.map((d) => {
                  return d.val;
                })}
              />
            </div>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="textBox">
            <div className="content d-flex justify-content-between" style={{ backgroundColor: "gray", color: "white" }}>
              <b>&nbsp;</b>
              <b> Günlük İstatistik </b>
              <b>&nbsp;</b>
            </div>
          </div>
        </div>
        <div className="col-1">
          <b style={{ float: "right", marginTop: "10px" }}>Başlangıç Tarihi :</b>
        </div>
        <div className="col-4">
          <input
            id="bastar"
            type="date"
            style={{ backgroundColor: "gray", color: "white", height: "40px" }}
            defaultValue={today}
            className="form-control form-control-sm"
          ></input>
        </div>
        <div className="col-1">
          <b style={{ float: "right", marginTop: "10px" }}>Bitiş Tarihi :</b>
        </div>
        <div className="col-4">
          <input
            id="bittar"
            type="date"
            style={{ backgroundColor: "gray", color: "white", height: "40px" }}
            defaultValue={today}
            className="form-control form-control-sm"
          ></input>
        </div>
        <div className="col-2">
          <button onClick={(e) => onClickCalismaRaporu(e)} style={{ height: "40px" }} className="blueBtn">
            Filtrele
          </button>
        </div>

        <div className="col-sm-12" style={{ flexDirection: "columnReverse", minWidth: "300px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
          <div className="textBox" style={{ width: "100%" }}>
            <div className="header">
              <center>
                <h4>
                  <b>Günlük Çalışma Raporu</b>
                </h4>
              </center>
            </div>
            <PieChart
              data={calismaRaporu.map((d) => {
                return parseInt(d.count);
              })}
              label={calismaRaporu.map((d) => {
                return d.gorev_durum;
              })}
            />
          </div>
        </div>
      </div>
      <div className="row" id="pdf4">
        <div className="col-sm-12" style={{ flexDirection: "columnReverse", minWidth: "300px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
          <div className="textBox" style={{ width: "100%" }}>
            <div className="header">
              <h4>
                <b>Ekip Günlük Çalışma Raporu</b>
              </h4>
            </div>
            <div className="content">
              <BarChart
                ad={"Ekip Günlük Çalışma Raporu"}
                noFixed={true}
                label={calismaRaporuEkip.map((d) => {
                  return d.label;
                })}
                data={calismaRaporuEkip.map((d) => {
                  return d.val;
                })}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  selectedTr: {
    backgroundColor: "#0047ab",
    color: "white",
    cursor: "pointer",
    width: "50%",
    height: "40px",
    textAlign: "center",
    border: "2px solid black",
  },
  defaultTr: {
    backgroundColor: "skyblue",
    color: "black",
    cursor: "pointer",
    width: "50%",
    height: "40px",
    textAlign: "center",
    border: "2px solid black",
  },
};
